import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions,
	createResourceMutationDefinitions,
	updateResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

// Lightweight query for resolving tariff name by ID (used by related entity edit pages)
export const TARIFF_NAME_QUERY = gql`
	query TariffName($id: Ulid!) {
		tariff(tariffId: $id) {
			tariffId
			name
		}
	}
`;

// Query for fetching a single tariff with list-level fields (used by post-save selection)
export const TARIFF_LIST_ITEM_QUERY = gql`
	query TariffListItem($id: Ulid!) {
		tariff(tariffId: $id) {
			tariffId
			name
			version
			description
			status
			needsVerification
			createdAt
			mainInFacility {
				facilityId
			}
		}
	}
`;

export const TARIFFS_LIST_QUERY = gql`
	query Tariffs($first: Int, $after: String) {
		tariffs(first: $first, after: $after) {
			nodes {
				tariffId
				name
				version
				description
				status
				needsVerification
				createdAt
				mainInFacility {
					facilityId
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const SET_MAIN_TARIFF_MUTATION = gql`
	mutation SetMainTariff($input: SetMainTariffInput!) {
		setMainTariff(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const TARIFF_QUERY = gql`
	query Tariff($id: Ulid!) {
		tariff(tariffId: $id) {
			tariffId
			name
			version
			description
			status
			sourceTariffId
			entryGracePeriodMinutes
			postPaymentGraceMinutes
			freeExitMinutes
			lostTicketFixedCharge
			lostTicketRateId
			reEntryChargeRateId
			needsVerification
			verificationReason
			verificationFlaggedAt
			createdAt
			updatedAt
			activatedAt
			deactivatedAt
			facility {
				name
			}
			sourceTariff {
				tariffId
				name
			}
			lostTicketRate {
				rateId
				rateTypeEnum
				flatRateAmount
			}
			reEntryChargeRate {
				rateId
				rateTypeEnum
				flatRateAmount
			}
			createdByUser {
				userId
				firstName
				lastName
			}
			pricingPolicies {
				pricingPolicyId
				name
			}
			limitPolicies {
				limitPolicyId
				name
			}
			mainInFacility {
				facilityId
			}
		}
	}
`;

export const TARIFF_CREATE_MUTATION = gql`
	mutation CreateTariff($input: CreateTariffInput!) {
		createTariff(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const TARIFF_UPDATE_MUTATION = gql`
	mutation UpdateTariff($input: UpdateTariffInput!) {
		updateTariff(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['tariffs'] = {
	document: TARIFFS_LIST_QUERY,
	dataPath: 'tariffs'
};

viewResourceQueryDefinitions['tariffs'] = {
	document: TARIFF_QUERY,
	dataPath: 'tariff'
};

createResourceMutationDefinitions['tariffs'] = {
	document: TARIFF_CREATE_MUTATION,
	operation: 'createTariff',
	getVariables: variables => ({ input: variables })
};

updateResourceMutationDefinitions['tariffs'] = {
	document: TARIFF_UPDATE_MUTATION,
	operation: 'updateTariff',
	getVariables: variables => ({ input: variables })
};
